import { handleAuthExpired, refreshAuthCookie } from "../app/views/auth/auth";

const API_BASE_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_API_BASE_URL || "" : "http://localhost:5001";

export async function apiRequest(
  endpoint: string,
  options: RequestInit = {}
) {
  const response = await fetch(
    `${API_BASE_URL}${endpoint}`,
    {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {})
      },
      ...options
    }
  );

  if (response.status === 401) {
    handleAuthExpired();
    throw new Error("Unauthorized: please log in again.");
  }

  if (!response.ok) {
    throw new Error(
      `API Error: ${response.status}`
    );
  }

  refreshAuthCookie();
  return response.json();
}